export const SET_PG_HOME_LINK = 'pg-home-link/SET_PG_HOME_LINK';

export default (state = null, action) => {
  switch (action.type) {
  case SET_PG_HOME_LINK: {
    if (typeof action.payload === 'string' && /^http[s]?:\/\/.*/.test(action.payload)) {
      return action.payload;
    }
    return state;
  }
  default:
    return state;
  }
};

export const setPGHomeLinkAction = payload => ({
  type: SET_PG_HOME_LINK,
  payload,
});



// WEBPACK FOOTER //
// ./src/client/redux/pg-home-link.js